import Vue from "vue";
import Vuex from "vuex";
import cart from "./modules/cart";
import country from "./modules/country";
import weddingList from "./modules/weddingList";
import wishlist from "./modules/wishlist";
import alert from "./modules/alert";
Vue.use(Vuex);

// Export the store instance directly (not a function)
export default new Vuex.Store({
  modules: {
    cart,
    country,
    weddingList,
    wishlist,
    alert,
  },
});
